import { API_HOST } from './api'
import axios from 'axios'

export async function ADDRESS_FIND(zip_code) {
    const response = await axios.get(`https://viacep.com.br/ws/${zip_code}/json/`);
    return response.data;
}

export async function CITY_TIME(state, city) {
    city = city.replace(' ', '%20');
    console.log(`${API_HOST}/cities/?state=${state}&city=${city}`);
    const response = await axios.get(`${API_HOST}/cities/?state=${state}&city=${city}`, {
        headers: {
            'Authorization': 'Bearer ' + window.localStorage.getItem('token')
        }
    });
    return response.data;
}


// WEBPACK FOOTER //
// ./src/services/address.js